import React, { useContext, useRef } from "react";
import ThemeContext from "../../theme/ThemeContext";
import { Route, Routes } from "react-router-dom";
import "../../scss/style.scss";
import { useAuth0 } from "@auth0/auth0-react";
import AppFooter from "../appFooter";
import AppHeader from "../appHeader";
import { PageLoader } from "./page-loader";
import { ProtectedRoute } from "./protected-route";
import "./AppStyles.scss";
import "@coreui/coreui-pro/dist/css/coreui.min.css";
import { CButton } from "@coreui/react";

// Only load route components when they are required. This reduces initial load time.
const Map = React.lazy(() => import("../routes/map/Map"));
const Metrics = React.lazy(() => import("../routes/metrics/Metrics"));
const Settings = React.lazy(() => import("../routes/settings/Settings"));

function App() {
  const { darkmode } = useContext(ThemeContext);
  const { logout, isLoading } = useAuth0();
  const { user } = useAuth0();

  if (isLoading) {
    return (
      <div className="page-layout">
        <PageLoader />
      </div>
    );
  }

  // Restrict access via email
  let email = user?.email;
  let email_domain = email?.split("@")[1];
  if (
    email_domain !== "stealth-power.com" &&
    email !== "robertcharland@comcast.net" &&
    email !== "robertcharland@energyzerosolutions.com" &&
    email_domain !== "merlinsolar.com" &&
    email_domain !== undefined
  ) {
    return (
      <>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <h3>You are not authorized</h3>
          You don't have permission to view this dashboard.
        </div>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <CButton
            className="back-to-login-btn"
            onClick={() => logout({ returnTo: window.location.origin })}
          >
            Return to login
          </CButton>
        </div>
      </>
    );
  }

  // If the user has not verified their email account
  if (!user?.email_verified && email_domain !== undefined) {
    return (
      <>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <h3>Please Verify your Email Account.</h3>
          An email was sent to your registered email account. Please check your
          email and verify your account by clicking the link, then try logging
          in again.
        </div>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <CButton
            className="back-to-login-btn"
            onClick={() => logout({ returnTo: window.location.origin })}
          >
            Return to login
          </CButton>
        </div>
      </>
    );
  }

  const main = useRef(null);

  // Setup structure of dash: header, routes, footer.
  return (
    <div className={darkmode ? "main-style-dark o2n-app" : "main-style-light"}>
      <AppHeader />
      <React.Suspense>
        <div className="body">
          <main
            data-testid="main"
            ref={main}
            style={{
              display: "flex",
              flexGrow: 1,
              minHeight: "100%",
            }}
          >
            <div className="container-fluid px-sm-0">
              <Routes>
                <Route path="/" element={<ProtectedRoute component={Map} />} />
                <Route
                  path="/metrics"
                  element={<ProtectedRoute component={Metrics} />}
                />
                <Route
                  path="/settings"
                  element={<ProtectedRoute component={Settings} />}
                />
              </Routes>
            </div>
          </main>
        </div>
      </React.Suspense>
      <div>
        <AppFooter />
      </div>
    </div>
  );
}

export default App;
